import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'persecutor_analysis'
const storeType = 'persecutorAnalysis'

export const PEPersecutorAnalysisCardActions = {
  initPePersecutorAnalysisCard: ({ commit }, index) => {
    commit('setPePersecutorAnalysisCardLock', { index, lock: true })
  },
  peFetchPersecutorAnalysisCards: async ({ commit, getters, dispatch }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  pePersecutorAnalysisCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            persecutor_facts: section.persecutor_facts,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPePersecutorAnalysisCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  pePersecutorAnalysisCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPePersecutorAnalysisCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  pePersecutorAnalysisCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            persecutor_facts: section.persecutor_facts,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPePersecutorAnalysisCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  pePersecutorAnalysisCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPePersecutorAnalysisCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  pePersecutorAnalysisCardAddSection: ({ commit }) => {
    commit('setPePersecutorAnalysisCardLock', { index: 'new', lock: false })
    commit('addPePersecutorAnalysisCardSection', {
      id: null,
      persecutor_facts: '',
      narrative: '',
    })
  },
  pePersecutorAnalysisCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PEPersecutorAnalysisCardMutations = {
  setPePersecutorAnalysisCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.PersecutorAnalysisCard) {
      Vue.set(state.partyEdit.partySections, 'PersecutorAnalysisCard', {})
    }
    Vue.set(state.partyEdit.partySections.PersecutorAnalysisCard, index, lock)
  },
  addPePersecutorAnalysisCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  pePersecutorAnalysisCardCreateUndo: state => state.partyEdit.asylumAssystant[storeType].pop(),
}

export const PEPersecutorAnalysisCardGetters = {
  pePersecutorAnalysisCardLock: state => index => state.partyEdit.partySections.PersecutorAnalysisCard[index],
  pePersecutorAnalysisCardHasNewSection: state => !!state.
    partyEdit.
    asylumAssystant[storeType]?.
    find(aka => aka.id === null),
}
